<template>
  <div>

    <headline>
      Räume
      <template v-slot:more>
        <room-create @reload="load"></room-create>
      </template>
    </headline>

    <loading v-show="loading"></loading>

    <card-full-invisible v-show="!loading">

      <template v-slot:action>
        Personenlimit anpassen<br>
        <div class="flex justify-between">
          <button-secondary @click="limitEnabled(true)" class="mr-2">
            <template slot="icon"><i class="fa fa-plus"></i></template>
            Limit Aktivieren
          </button-secondary>
          <button-secondary @click="limitEnabled(false)">
            <template slot="icon"><i class="fa fa-minus"></i></template>
            Limit aufheben
          </button-secondary>
        </div>
      </template>

      <tailwind-table
          :header="['Raum', 'Etage', 'Bereiche', 'Anzahl Schreibtische', 'Fest', 'Frei', 'Personenbegrenzung', '']"
          :has_filter=true>
        <template slot="search">
          <input @search="load" type="search" placeholder="Suche..." v-model="search"  class="form-input shadow-sm focus:ring-secondary focus:border-secondary block w-full sm:text-sm border-gray-300 rounded-md" />
        </template>
        <template slot="filter">
          <floor-select class="px-2" v-model="selectedFloor" :filter="true"></floor-select>

        </template>
        <tr v-for="(room, i) in rooms" :key="room.id" :class="{'bg-white': i % 2}">
          <td class="px-6 py-2">
            <a :href="`/admin/pages/rooms/${room.id}`">
              {{ room.name }}
            </a>
          </td>
          <td class="px-6 py-2">
            <a v-if="floor" :href="`/admin/pages/floors/${floor.id}`">
              {{ floor.name }}
            </a>
          </td>
          <td class="px-6 py-2">
            <a v-for="zone in zones" :href="`/admin/pages/zones/${zone.id}`">
              {{ zone.name }}
            </a>
          </td>
          <td class="px-6 py-2">{{ room.desks.length }}</td>
          <td class="px-6 py-2">{{ room.desks.filter(desk => desk.user_id !== null).length }}</td>
          <td class="px-6 py-2">{{ room.desks.filter(desk => desk.user_id === null).length }}</td>
          <td class="px-6 py-2">
                        <span class="text-gray-500" v-show="!room.has_limit_persons_enabled">
                            {{ room.limit_persons }} (inaktiv)
                        </span>

            <span v-show="room.has_limit_persons_enabled">
                            {{ room.limit_persons }}
                        </span>
          </td>
          <td class="px-6 py-2">
            <a :href="`/admin/pages/rooms/${room.id}`">
              <button-white>
                Anzeigen
              </button-white>
            </a>
          </td>
        </tr>
      </tailwind-table>

    </card-full-invisible>


  </div>
</template>

<script>

import Headline from "../components/UI/Headline";
import TailwindTable from "../components/UI/TailwindTable";
import ButtonSecondary from "../components/UI/ButtonSecondary";
import ButtonPrimary from "../components/UI/ButtonPrimary";
import RoomCreate from "../components/RoomCreate";
import RoomEdit from "../components/RoomEdit";
import CardFullInvisible from "../components/UI/CardFullInvisible.vue";
import ButtonWhite from "../components/UI/ButtonWhite.vue";
import Loading from "../components/UI/Loading.vue";
import SelectMenu from "../components/UI/SelectMenu.vue";
import FloorSelect from "../components/FloorSelect.vue";
import InputText from "../components/UI/InputText.vue";

export default {
  name: "Rooms",

  components: {
    InputText,
    FloorSelect,
    SelectMenu,
    Loading,
    ButtonWhite,
    CardFullInvisible,
    RoomEdit,
    RoomCreate,
    ButtonPrimary,
    ButtonSecondary,
    TailwindTable,
    Headline,
  },

  data: () => ({
    rooms: [],
    loading: false,
    showModal: false,
    page: 'overview',
    selectedRoom: {},
    selectedFloor: null,
    search: ""
  }),

  mounted() {
    this.load();
  },

  watch: {
    selectedFloor() {
      this.load();
    },
  },

  methods: {
    load() {
      this.loading = true;
      let params = {};
      if (this.selectedFloor) {
        params["floor_id"] = this.selectedFloor;
      }
      if(this.search){
        params["search"] = this.search
      }
      window.axios.get('/admin/rooms', {
        params
      }).then((response) => {
        this.rooms = response.data.data;
        this.loading = false;
      });
    },
    limitEnabled(limit) {
      this.loading = true;
      window.axios.post('/admin/group', {
        has_limit_persons_enabled: limit,
      }).then(() => {
        this.load();
      });
    }
  }
}
</script>

<style scoped>

</style>
